/**
 * Portal Manta · BenchmarkingPage
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { DADOS } from '../../data/lotes-pr.js';
import { V, S, fmtNum, sumBy, fmtBRL } from '../../globals.js';
import { CONSOL_FIN } from '../../data/consol-fin.js';
import { THl, TH, TDl, TD } from '../../app-globals.js';
import { M } from '../../tokens/colors.js';

const BenchmarkingPage = memo(function BenchmarkingPage_Inner(){
  const lotes = ['3','4','5'];
  const cores = {'3':V.gn,'4':V.bl,'5':V.or};
  const data = lotes.map(sig=>{
    const d = DADOS[sig]||{};
    const cf = CONSOL_FIN[sig]||{};
    const ext = parseFloat((d.extensao||'').replace(/[^\d,.]/g,'').replace(',','.'))||0;
    const totSicro = Object.values(cf).reduce((s,arr)=>s+sumBy(arr,'v'),0);
    return {sig,nome:d.nome,ext,capex:d.capex_total_b,tir:d.tir,totSicro,
      rkm:ext?totSicro/ext:0,
      pav:sumBy(cf['PAVIMENTACAO']||[],'v'),
      ter:sumBy(cf['TERRAPLENOS E CONTENCOES']||[],'v'),
      drn:sumBy(cf['DRENAGEM']||[],'v'),
      oae:sumBy(cf['OAES']||[],'v')};
  });
  const benchRkm = data.reduce((s,d)=>s+d.rkm,0)/data.length;
  return(<div style={S.page}>
    <div style={S.h1}>Benchmarking · Análises Consolidadas L3·L4·L5</div>
    <div style={S.sub}>Comparativo cross-lote · benchmarks Paraná ANTT · referência para novos estudos</div>
    <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:10,marginBottom:14}}>
      {data.map(d=>(<div key={d.sig} style={{...S.cardP,borderTop:'4px solid '+cores[d.sig]}}>
        <div style={{fontSize:9.5,fontWeight:700,color:cores[d.sig],letterSpacing:.4}}>L{d.sig} · {d.nome}</div>
        <div style={{fontSize:18,fontWeight:700,color:V.br,marginTop:4}}>{fmtBRL(d.rkm,0)}/km</div>
        <div style={{fontSize:10,color:V.gr,marginTop:2}}>SICRO {fmtBRL(d.totSicro,0)} · CAPEX R$ {d.capex} bi · TIR {(d.tir*100).toFixed(2)}%</div>
        <div style={{...S.pillBase,background:d.rkm>benchRkm?V.or:V.gn,color:'#fff',marginTop:8,padding:'2px 8px',display:'inline-block'}}>
          {d.rkm>benchRkm?'+':''}{((d.rkm/benchRkm-1)*100).toFixed(1)}% vs média
        </div>
      </div>))}
    </div>
    <div style={S.h2}>Comparativo R$/km por disciplina</div>
    <div style={{...S.card,overflow:'auto',marginBottom:14}}>
      <table style={{width:'100%',borderCollapse:'collapse',fontSize:11}}>
        <thead style={S.thRow}><tr style={{borderBottom:'2px solid '+V.b1}}>
          <th style={THl}>Disciplina</th>
          {data.map(d=>(<th key={d.sig} style={{...TH,background:cores[d.sig]+'33'}}>L{d.sig} R$/km</th>))}
          <th style={TH}>Média</th><th style={TH}>L5÷L3</th>
        </tr></thead>
        <tbody>
          {[['Pavimentação','pav'],['Terraplenagem','ter'],['Drenagem','drn'],['OAEs','oae']].map(([l,k])=>{
            const vals = data.map(d=>d.ext?d[k]/d.ext:0);
            const media = vals.reduce((s,v)=>s+v,0)/vals.length;
            const ratio = vals[0]?vals[2]/vals[0]:0;
            return(<tr key={k} style={S.trLine}>
              <td style={{...TDl,fontWeight:700}}>{l}</td>
              {vals.map((v,i)=>(<td key={i} style={{...TD,fontFamily:'monospace'}}>R$ {fmtNum(v,0)}</td>))}
              <td style={{...TD,fontWeight:700}}>R$ {fmtNum(media,0)}</td>
              <td style={{...TD,fontWeight:700,color:ratio>2?V.or:ratio>1.3?(V.am||'#d97706'):V.gn}}>{ratio.toFixed(2)}×</td>
            </tr>);
          })}
        </tbody>
      </table>
    </div>
    <div style={S.h2}>Premissas de benchmarking ANTT-PR</div>
    <div style={{...S.card,overflow:'hidden',marginBottom:14}}>
      <table style={{width:'100%',borderCollapse:'collapse',fontSize:10.5}}>
        <tbody>
          <tr style={S.trLine}><td style={{...TDl,width:'40%',fontWeight:700}}>R$/km médio (3 lotes)</td><td style={TDl}>R$ {fmtNum(benchRkm,0)}/km</td></tr>
          <tr style={S.trLine}><td style={{...TDl,fontWeight:700}}>Multiplicador contexto urbano</td><td style={TDl}>×1,15 periurbano · ×1,35 urbano</td></tr>
          <tr style={S.trLine}><td style={{...TDl,fontWeight:700}}>BDI ANTT-PR padrão</td><td style={TDl}>23,20% - 23,39%</td></tr>
          <tr style={S.trLine}><td style={{...TDl,fontWeight:700}}>SICRO ÷ CAPEX</td><td style={TDl}>6% - 11%</td></tr>
          <tr style={S.trLine}><td style={{...TDl,fontWeight:700}}>TIR ANTT-PR</td><td style={TDl}>10,64% - 12,33%</td></tr>
        </tbody>
      </table>
    </div>
  </div>);
});

export { BenchmarkingPage };
export default BenchmarkingPage;
